module.exports = __webpack_public_path__ + "static/media/che.938e97b5.mp3";